var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-container" },
    [
      _c(
        "TenderHead",
        { ref: "tenderEditHead", attrs: { tenderGeneral: _vm.tender.general } },
        [
          _c(
            "div",
            {
              staticClass: "float-left",
              attrs: { slot: "status" },
              slot: "status",
            },
            [
              _c("div", { staticClass: "tender-status tender-bid-status" }, [
                _vm._v("\n        " + _vm._s(_vm.statusText) + "\n      "),
              ]),
              _vm._v(" "),
              _vm.showUpdatorInfo
                ? _c(
                    "HKLGrayHint",
                    { staticClass: "text-field tender-bid-updated-by" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("lastUpdatedBy", [
                              _vm.currentBid.vendorUpdatorName,
                              _vm.dateUtil.format(
                                _vm.currentBid.vendorUpdatedAt,
                                "DD MMM YY HH:mm"
                              ),
                            ])
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              !_vm.showQuery
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.exportPDF(_vm.exportOptions[0])
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.exportBid")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showQuery
                ? _c("ExportPdfWithOptions", {
                    attrs: { options: _vm.exportOptions },
                    on: {
                      "export:pdf": function (val) {
                        return _vm.exportPDF(val)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isInvited
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.startBid()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.startBid")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editView
                ? _c(
                    "div",
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.save")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.openSubmitModal()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.submit")))]
                      ),
                      _vm._v(" "),
                      _c("submit-bid", { ref: "subitBidModal" }),
                      _vm._v(" "),
                      _c("WarnTenderUpdate", { ref: "warnTenderUpdateModal" }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showWithDrawn
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openWithdrawModal()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.withdraw")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.general.version
        ? _c("RecentAddendum", {
            attrs: {
              tenderId: _vm.general.id,
              isBid: true,
              includePendingChange:
                !_vm.currentTender.general.hasPendingAddendum,
              addendumVersion: _vm.addendumVersion,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "TenderTabsContainer",
        {
          attrs: {
            isTender: _vm.isTender,
            tabsInvalid: _vm.tabsInvalid,
            showQueryTab: _vm.showQuery,
          },
        },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              !_vm.showQuery
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn--darkblue tender-sticky-button mini-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.exportPDF(_vm.exportOptions[0])
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.exportBid")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showQuery
                ? _c("export-pdf-with-options", {
                    attrs: { options: _vm.exportOptions },
                    on: {
                      "export:pdf": function (val) {
                        return _vm.exportPDF(val)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.editView
                ? _c("div", { staticStyle: { "margin-left": "5px" } }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--orange tender-sticky-button mini-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn--orange tender-sticky-button mini-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openSubmitModal()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.submit")))]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showWithDrawn
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn--orange tender-sticky-button mini-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.openWithdrawModal()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.withdraw")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "general" }, slot: "general" },
            [
              _c("General", {
                attrs: {
                  general: _vm.general,
                  isContractor: true,
                  tenderBidId: _vm.tenderBidId,
                },
                on: {
                  "update:general": function ($event) {
                    _vm.general = $event
                  },
                },
              }),
              _vm._v(" "),
              _vm.editView || _vm.isInvited
                ? _c("DeclineTender", {
                    attrs: { tenderBidId: _vm.tenderBidId },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("ScopeOfWork", {
            attrs: { slot: "scopeOfWork", items: _vm.general.scopeOfWorks },
            slot: "scopeOfWork",
          }),
          _vm._v(" "),
          _c("ItemsServicesBid", {
            ref: "itemsServicesTab",
            attrs: {
              slot: "itemServices",
              itemServices: _vm.service,
              editView: _vm.editView,
              bidService: _vm.bidService,
              totalFee: _vm.bidService.totalFee,
            },
            on: {
              "update:bidService": function ($event) {
                _vm.bidService = $event
              },
              "update:bid-service": function ($event) {
                _vm.bidService = $event
              },
              "update:totalFee": _vm.updateTotalFee,
            },
            slot: "itemServices",
          }),
          _vm._v(" "),
          _c("Attachments", {
            attrs: {
              slot: "fileUpload",
              attachment: _vm.attachment,
              tenderId: _vm.general.id,
              tenderBidId: _vm.tenderBidId,
              editView: _vm.editView,
              attachmentDesc: _vm.attachment.description,
              zipPrefix: _vm.zipPrefix,
            },
            on: {
              "update:attachment": function ($event) {
                _vm.attachment = $event
              },
            },
            slot: "fileUpload",
          }),
          _vm._v(" "),
          _c("TermsConditions", {
            ref: "termsConditionsTab",
            attrs: {
              slot: "termsConditions",
              isContractorView: true,
              tenderId: _vm.general.id,
              zipName: _vm.zipNames.terms,
              editView: _vm.editView,
              totalFee: _vm.bidService.totalFee,
              tncInfo: _vm.tncInfo,
              isTender: _vm.isTender,
            },
            on: {
              "update:tncInfo": function ($event) {
                _vm.tncInfo = $event
              },
              "update:tnc-info": function ($event) {
                _vm.tncInfo = $event
              },
            },
            slot: "termsConditions",
          }),
          _vm._v(" "),
          _vm.showQuery
            ? _c("TenderQueryAccordion", {
                attrs: { slot: "query" },
                slot: "query",
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("Modal", { ref: "withdrawBid", attrs: { modalId: "withdrawBid" } }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _c("p", { staticClass: "modal-pure-text" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("vendor.bid.withdraw.popupTitle")) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { type: "button", "aria-label": "Close reveal" },
              on: {
                click: function ($event) {
                  return _vm.closeWithdrawModal()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "submit" },
              on: {
                click: function ($event) {
                  return _vm.withdrawn()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }